<div *ngIf="currentUser" class="container">
  <div class="print"><app-landing></app-landing></div>
  <p class="welcome-header noprint">Welcome, {{ currentUser.MemberName }}</p>
  <div class="important-section">
    <p class="important-header">Important</p>
    <ul class="important-list">
      <li>The figures shown below are estimates only.</li>
      <li *ngIf="!currentUser.Marrbkdn">
        All amounts shown are prior to any deductions (such as taxes, etc.),
        reflect your entire benefit accrued, and have not been adjusted for any
        division of benefits under a court ordered conjugal breakdown.
      </li>
      <li *ngIf="currentUser.Marrbkdn">
        All amounts shown are prior to any deductions (such as taxes, etc.), and
        have been adjusted for the division of benefits with your former spouse
        as a result of the breakdown of a marriage or common law relationship.
      </li>
      <li>
        The estimates are based on data that is updated at a point in time and
        are subject to change and not guaranteed to be accurate.
      </li>
      <li>
        Actual retirement benefits will be based on plan terms and data at the
        time of retirement.
      </li>
      <li>
        Service used for the projections are assuming full time (100%)
        employment unless overridden.
      </li>
    </ul>
  </div>
  <form [formGroup]="calculatorInputForm">
    <div class="section page-break-before">
      <h4><b>Your Personal Details</b></h4>
      <div class="content">
        <div class="row">
          <div class="column">
            <p><b>Name</b></p>
            <p>{{ currentUser.MemberName }}</p>
          </div>
          <div class="column">
            <p><b>Your Date of Birth</b></p>
            <p>{{ currentUser.DOB | date : "MMM dd, yyyy" }}</p>
          </div>
          <div class="column" *ngIf="hasSpouse()">
            <p><b>Spouse Date of Birth</b></p>
            <p>{{ currentUser.SPSDOB | date : "MMM dd, yyyy" }}</p>
          </div>
          <div class="column">
            <p><b>NWMO ID</b></p>
            <p>{{ currentUser.IDNumber }}</p>
          </div>
          <div class="column">
            <div class="center-vertically">
              <p><b>Average Pensionable Earnings (RPP)</b></p>
              <a
                (click)="openRppAndSPSDialog()"
                *ngIf="retirementEvents?.SPPFlag"
              >
                <img src="/assets/icons/dialog-icon.svg" />
              </a>
              <a (click)="openRppDialog()" *ngIf="!retirementEvents?.SPPFlag">
                <img src="/assets/icons/dialog-icon.svg" />
              </a>
            </div>
            <mat-form-field appearance="outline">
              <span class="dollar-sign">$</span>
              <input
                matInput
                class="dollar-input"
                type="text"
                formControlName="rppEarnings"
                [validation]="false"
                mask="separator.2"
                thousandSeparator=","
              />
            </mat-form-field>
          </div>
          <div class="column" *ngIf="retirementEvents?.EPSFlag">
            <div class="center-vertically">
              <p><b>Average Pensionable Earnings (ESPS)</b></p>
              <a (click)="openEspsDialog()">
                <img src="/assets/icons/dialog-icon.svg" />
              </a>
            </div>
            <mat-form-field appearance="outline">
              <span class="dollar-sign">$</span>
              <input
                matInput
                class="dollar-input"
                type="text"
                formControlName="espsEarnings"
                [validation]="false"
                mask="separator.2"
                separatorLimit=","
              />
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>
    <div class="section">
      <h4><b>Your Assumptions</b></h4>
      <p>
        The model currently uses the assumptions below to project your earnings
        and service to future retirement dates. If you expect your annual
        earnings to grow at a different rate or your percentage of full-time
        work in future years to differ, you can change these assumptions below.
      </p>
      <div class="assumptions-container">
        <div class="assumptions-content">
          <div class="center-vertically">
            <p><b>Yearly Salary Increase</b></p>
            <a (click)="openYearlySalaryIncrease()">
              <img src="/assets/icons/dialog-icon.svg" />
            </a>
          </div>
          <mat-form-field appearance="outline">
            <input
              matInput
              class="percentage-input"
              type="number"
              placeholder="0"
              formControlName="yearlySalaryIncrease"
            />
            <span class="percentage-sign">%</span>
          </mat-form-field>
        </div>
        <div class="flex-container">
          <div class="assumptions-content">
            <div class="center-vertically">
              <p><b>Future Percentage of Work</b></p>
              <a (click)="futurePercentageofWorkDialog()">
                <img src="/assets/icons/dialog-icon.svg" />
              </a>
            </div>
            <mat-form-field appearance="outline">
              <input
                matInput
                class="percentage-input"
                placeholder="0"
                type="number"
                formControlName="futurePercentageOfWork"
              />
              <span class="percentage-sign">%</span>
            </mat-form-field>
          </div>
          <div
            class="assumptions-content"
            *ngIf="
              calculatorInputForm.get('futurePercentageOfWork')?.value != 100
            "
          >
            <div class="center-vertically">
              <p><b>Effective Date</b></p>
              <a (click)="effectiveDateDialog()">
                <img src="/assets/icons/dialog-icon.svg" />
              </a>
            </div>
            <mat-form-field appearance="outline">
              <input
                matInput
                formControlName="effectiveDate"
                [matDatepicker]="picker"
              />
              <mat-datepicker-toggle
                matIconSuffix
                [for]="picker"
              ></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
          </div>
        </div>
        <div class="flex-container">
          <div class="radio-button-container">
            <div class="center-vertically">
              <p>
                <b
                  >Planning on leaving the NWMO prior to your retirement
                  eligibility?</b
                >
              </p>
            </div>
            <mat-radio-group formControlName="isLeavingNwmo">
              <mat-radio-button [value]="false">No</mat-radio-button>
              <mat-radio-button [value]="true">Yes</mat-radio-button>
            </mat-radio-group>
          </div>
          <div
            class="assumptions-content"
            *ngIf="calculatorInputForm.get('isLeavingNwmo')?.value == true"
          >
            <div class="center-vertically">
              <p><b>Departure Date (prior to retirement eligibility)</b></p>
              <a (click)="departureDateDialog()">
                <img src="/assets/icons/dialog-icon.svg" />
              </a>
            </div>
            <mat-form-field appearance="outline">
              <mat-label>Departure Date</mat-label>
              <input
                matInput
                formControlName="departureDate"
                [matDatepicker]="picker"
              />
              <mat-datepicker-toggle
                matIconSuffix
                [for]="picker"
              ></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
              <mat-error>
                Departure date should fall between tomorrow and before age 55
              </mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>
    <div
      class="page-break-before"
      *ngIf="
        calculatorInputForm.get('departureDate')?.value != null &&
        calculatorInputForm.get('isLeavingNwmo')?.value == true &&
        this.calculatorInputForm.valid
      "
    >
      <h4><b>Your Projected Pension on Departure</b></h4>
      <mat-progress-bar
        class="projected-pension-loader"
        *ngIf="isCalculating"
        mode="indeterminate"
      ></mat-progress-bar>

      <p class="projected-pension-header">
        Here’s a summary of your deferred pension information if you
        <b>left NWMO on {{ getDepartureDate() }}</b>
      </p>
      <table
        mat-table
        [dataSource]="departurePensionData"
        class="mat-elevation-z2"
      >
        <ng-container matColumnDef="column1">
          <td mat-cell *matCellDef="let element">{{ element.column1 }}</td>
        </ng-container>

        <<ng-container matColumnDef="column2">
          <td
            mat-cell
            *matCellDef="let element"
            [innerHTML]="element.column2"
          ></td>
        </ng-container>
        <tr
          mat-row
          *matRowDef="let row; columns: deperatureDisplayedColumns"
        ></tr>
      </table>
      <p class="projected-pension-footer" *ngIf="retirementEvents?.EPSFlag">
        *Once you stop working, or retire from NWMO, your combined RPP and ESPS
        pension increases each January 1st at 50% of the Ontario Consumer Price
        Index (CPI), up to 4%.
        <b>Note, the pension shown here does not include indexation.</b>
      </p>
      <p class="projected-pension-footer" *ngIf="!retirementEvents?.EPSFlag">
        Once you stop working, or retire from NWMO, your pension increases each
        January 1st at 100% of the Ontario Consumer Price Index (CPI), up to 8%.
        <b>Note, the pension shown here does not include indexation.</b>
      </p>
    </div>
    <svg *ngIf="inPrint" width="1000px" height="10px" version="1.1">
      <rect width="100%" height="10px" fill="white" />
    </svg>
    <div *ngIf="calculatorInputForm.get('isLeavingNwmo')?.value == false">
      <div>
        <h4><b>Your Pension Projections</b></h4>
        <p>
          The visualizations below show your projected pension amounts at
          various potential retirement dates.<br /><br />Here’s a summary of
          your key retirement ages and dates if you continue to work at NWMO
          until then:
        </p>
      </div>
      <div class="pension-projections-table">
        <mat-progress-bar
          *ngIf="isCalculating"
          mode="indeterminate"
        ></mat-progress-bar>
        <table
          mat-table
          [dataSource]="projectTableData"
          class="mat-elevation-z2"
        >
          <ng-container matColumnDef="retirementType">
            <th mat-header-cell *matHeaderCellDef class="header-cell">
              Retirement Type
            </th>
            <td mat-cell *matCellDef="let element">
              <span>
                {{ element.retirementType }}
                <a
                  *ngIf="
                    element.retirementType ==
                    'Your custom defined retirement date'
                  "
                  (click)="deleteCustomRetDate()"
                >
                  <img src="/assets/icons/delete-icon.svg" />
                </a>
              </span>
            </td>
          </ng-container>

          <ng-container matColumnDef="age">
            <th mat-header-cell *matHeaderCellDef class="header-cell">Age</th>
            <td mat-cell *matCellDef="let element">
              {{ element.age }}
            </td>
          </ng-container>

          <ng-container matColumnDef="date">
            <th mat-header-cell *matHeaderCellDef class="header-cell">Date</th>
            <td mat-cell *matCellDef="let element">
              {{ formatDateFullMonth(element.date) }}
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
        <div class="center-vertically" style="margin-top: 30px">
          <p><b>Looking to add a retirement date to compare?</b></p>
          <a (click)="openRetirementDateDialog()">
            <img src="/assets/icons/dialog-icon.svg" />
          </a>
        </div>
        <div class="customRetDatePicker">
          <p><b>Retirement Date</b></p>
          <mat-form-field appearance="outline">
            <mat-label>Select Date</mat-label>
            <input
              matInput
              formControlName="customRetDate"
              [matDatepicker]="pickerCustomRetDate"
            />
            <mat-datepicker-toggle
              matIconSuffix
              [for]="pickerCustomRetDate"
            ></mat-datepicker-toggle>
            <mat-datepicker #pickerCustomRetDate></mat-datepicker>
            <mat-error
              *ngIf="
                calculatorInputForm.get('customRetDate')?.hasError('dateRange')
              "
            >
              Your Retirement Date must be a future date that is after age 55
              and on or prior to December 1 of the calendar year in which you
              turn age 71.
            </mat-error>
            <mat-error
              *ngIf="
                calculatorInputForm.get('customRetDate')?.hasError('dateExists')
              "
            >
              The Custom Retirement Date cannot be the same date as one of the
              projected retirement dates
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="page-break-before">
        <div class="graph-header" *ngIf="!isCalculating && !isPortrait">
          <h6>Comparison of Retirement Types</h6>
          <a
            (click)="openComparisonRetirementTypes()"
            *ngIf="!retirementEvents?.EPSFlag"
          >
            <img src="/assets/icons/dialog-icon.svg" />
          </a>
          <a
            (click)="openComparisonRetirementTypesEsps()"
            *ngIf="retirementEvents?.EPSFlag"
          >
            <img src="/assets/icons/dialog-icon.svg" />
          </a>
        </div>
        <p class="graph-header" *ngIf="isPortrait">
          <b class="important"
            >To view the graph, rotate your device to landscape view.</b
          >
        </p>
        <div *ngIf="!isPortrait" id="chartdiv"></div>
      </div>

      <div class="benefits-table__text" *ngIf="!isPortrait">
        <p>
          <b class="important">Interactive Graph</b>: To see how your monthly
          pension could be affected by your retirement date,
          <b>click on a retirement date below the above chart.</b>
        </p>
      </div>
      <div *ngIf="selectedOptionalBenefits" class="benefits-table">
        <table
          mat-table
          [dataSource]="
            selectedOptionalBenefits.RetirementBenefits.OptionalBenefits
          "
          class="mat-elevation-z2"
        >
          <ng-container matColumnDef="desc">
            <th mat-header-cell *matHeaderCellDef class="header-cell">
              Form of Pension Payment (Monthly)
              <a (click)="openPensionPaymentDialog()">
                <img src="/assets/icons/dialog-icon.svg" />
              </a>
            </th>
            <td mat-cell *matCellDef="let element">
              <span>
                {{ element.FormOfPensionName }}
              </span>
            </td>
          </ng-container>

          <ng-container matColumnDef="Pre65Total">
            <th mat-header-cell *matHeaderCellDef class="header-cell">
              Total up to age 65
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.Pre65Total | currency : "USD" : "symbol" : "1.0-0" }}
            </td>
          </ng-container>

          <ng-container matColumnDef="Post65Total">
            <th mat-header-cell *matHeaderCellDef class="header-cell">
              Total Post age 65
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.Post65Total | currency : "USD" : "symbol" : "1.0-0" }}
            </td>
          </ng-container>

          <ng-container matColumnDef="SurvivorPost65Total">
            <th mat-header-cell *matHeaderCellDef class="header-cell">
              Total Survivor Post age 65
            </th>
            <td mat-cell *matCellDef="let element">
              {{
                element.SurvivorPost65Total
                  | currency : "USD" : "symbol" : "1.0-0"
              }}
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="optionalBenefitsColumns"></tr>
          <tr
            mat-row
            *matRowDef="let row; columns: optionalBenefitsColumns"
          ></tr>
        </table>
      </div>
    </div>
  </form>
  <app-print-dialog-dump
    class="print"
    [displayEffectiveDate]="
      calculatorInputForm.get('futurePercentageOfWork')?.value != 100
    "
    [displayRetirementDate]="true"
    [displayESPS]="retirementEvents?.EPSFlag"
    [displayMarried]="hasSpouse()"
  ></app-print-dialog-dump>
  <div class="report-container noprint">
    <h4><b>Your Report</b></h4>
    <p>
      Select the ‘Generate Report’ button below to save/print your complete
      report. Your report will include everything that is currently visible plus
      any hidden content such as the Disclaimer, Terms & Conditions, Actuarial
      Assumptions and info icon popups. For more information on the pension plan,
      refer to the NWMO pension booklet located on the intranet and your most
      recent annual pension statement.
    </p>
    <button
      mat-flat-button
      color="primary"
      (click)="print()"
      [disabled]="isCalculating"
    >
      Generate Report
    </button>
  </div>
</div>
